<template>
  <component
    :is="element"
    class="
      product-prices
      text-desktop-12-uc-desktop
      text-mobile-12-uc-mobile
    "
    :class="[
      $blockClass(blockClass, 'prices'),
      { 'product-prices--reverse': reverse },
    ]"
  >
    <span
      v-if="formattedCompareAtPrice && !reverse"
      class="product-prices__compare-at-price"
      :class="$blockClass(blockClass, 'compare-at-price')"
      v-html="formattedCompareAtPrice"
    />

    <span
      class="product-prices__price"
      :class="[
        $blockClass(blockClass, 'price'),
        { 'product-prices__price--on-sale': formattedCompareAtPrice },
      ]"
      v-html="formattedPrice"
    />

    <span
      v-if="formattedCompareAtPrice && reverse"
      class="product-prices__compare-at-price"
      :class="$blockClass(blockClass, 'compare-at-price')"
      v-html="formattedCompareAtPrice"
    />

    <span
      v-if="available === false"
      class="product-prices__sold-out"
      :class="$blockClass(blockClass, 'sold-out')"
      v-html="$string('product.prices.sold_out')"
    />

    <slot name="info" />
  </component>
</template>

<script>

/**
 * Vue: Product prices
 * -----------------------------------------------------------------------------
 * Global product prices template.
 *
 * @param {Boolean} [available] - If the product is available.
 * @param {String} [blockClass] - Block level class to apply to all elements.
 * @param {Number|Boolean} compareAtPrice - Compare at price if it exists.
 * @param {String} [element] - Custom element override.
 * @param {Number} price - Product price, in cents format.
 * @param {Boolean} [reverse] - Reverse order of prices.
 *
 */
export default {
  name: 'ProductPrices',

  props: {
    available: {
      type: Boolean,
      default: true,
    },
    blockClass: {
      type: String,
      default: '',
    },
    compareAtPrice: {
      type: [Boolean, Number, null],
      default: false,
      required: true,
    },
    element: {
      type: String,
      default: 'p',
    },
    price: {
      type: [Boolean, Number],
      default: 0,
      required: true,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      cnvsGlobal: true,
    }
  },

  computed: {

    /**
     * Compute compare at price template.
     * @returns {String}
     */
    formattedCompareAtPrice() {
      return this.compareAtPrice && this.price < this.compareAtPrice
        ? this.$formatMoney(this.compareAtPrice, window.cnvs.store.moneyFormat)
        : ''
    },

    /**
     * Compute price template.
     * @returns {String}
     */
    formattedPrice() {
      if (this.price === false) {
        return this.$string('accessibility.loading')
      }

      if (this.price <= 0) {
        return this.$string('product.prices.free')
      }

      return this.price ? this.$formatMoney(this.price, window.cnvs.store.moneyFormat) : ''
    },
  },
}
</script>
